import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector, Field } from 'redux-form';
import { I18n, Translate } from 'react-redux-i18n';

import Button from '../../../inputs/button/Button';
import AddForm from '../../addform/AddForm';
import FormActions from '../../formactions/FormActions';
import FormField from '../../formfield/FormField';
import {
  LocationValidations,
  LocationFieldFormat,
  LocationFieldNormalize
} from '../../../../models';

export class LocationInfoForm extends Component {
  handleSiteSelect = (_, value) => {
    this.props.onSiteSelect(value.id);
  };
  handleAreaSelect = (_, value) => {
    this.props.onAreaSelect(value);
  };
  render() {
    const sites = this.props.sites
      ? this.props.sites.map(site => ({
          value: site,
          label: site.name
        }))
      : [];

    const areas =
      this.props.site &&
      this.props.site.id &&
      this.props.site.id in this.props.areas &&
      this.props.areas[this.props.site.id].map(item => ({
        value: item,
        label: item.name
      }));

    const zones =
      this.props.area &&
      this.props.area.id &&
      this.props.area.id in this.props.zones &&
      this.props.zones[this.props.area.id].map(zone => ({
        value: zone,
        label: zone.name
      }));
    return (
      <AddForm onSubmit={this.props.handleSubmit}>
        <Field
          name="name"
          label={I18n.t('add.location.name.label')}
          type="text"
          placeholder={I18n.t('add.location.name.placeholder')}
          component={FormField}
          validate={LocationValidations.name}
        />
        <Field
          name="macAddress"
          label={I18n.t('add.location.id.label')}
          type="text"
          placeholder={I18n.t('models.location.locationIdPlaceholder')}
          readOnly={this.props.isEditing}
          component={FormField}
          validate={LocationValidations.macAddress}
          format={LocationFieldFormat.macAddress}
          normalize={LocationFieldNormalize.macAddress}
        />
        <Field
          name="site"
          label={I18n.t('add.location.site.label')}
          type="select"
          component={FormField}
          placeholder={I18n.t('add.location.site.placeholder')}
          readOnly={this.props.isEditing}
          options={sites}
          onChange={this.handleSiteSelect}
          validate={LocationValidations.site}
        />
        <Field
          name="area"
          label={I18n.t('add.location.area.label')}
          type="select"
          component={FormField}
          placeholder={I18n.t('add.location.area.placeholder')}
          readOnly={this.props.isEditing}
          options={areas}
          onChange={this.handleAreaSelect}
          validate={LocationValidations.area}
        />
        <Field
          name="zone"
          label={I18n.t('add.location.zone.label')}
          type="select"
          component={FormField}
          placeholder={I18n.t('add.location.zone.placeholder')}
          readOnly={this.props.isEditing}
          options={zones}
          validate={LocationValidations.zone}
        />
        <FormActions>
          <Button>
            {this.props.isEditing ? (
              <Translate value="edit.edit" />
            ) : (
              <Translate value="add.add" />
            )}
          </Button>
        </FormActions>
      </AddForm>
    );
  }
}

const selector = formValueSelector('addlocation');
const mapStateToProps = state => {
  return {
    site: selector(state, 'site'),
    area: selector(state, 'area')
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'addlocation',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    enableReinitialize: true
  })(LocationInfoForm)
);



// WEBPACK FOOTER //
// ./src/components/forms/addlocationform/locationinfoform/LocationInfoForm.js